
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
// eslint-disable-next-line
import { Validation } from 'vuelidate' //Don't remove this import, otherwise validations isnt recognized
import Axios from 'axios'
import { gtag, gtagSendToIdContactsRequest, gtagSendToIdApplicationRequest, gtagSendToIdDownloadsRequest } from "../core/constants";
import { BASE_URL, ANTIFORGERY_INPUT_NAME } from '../helpers/constants'
import { FIRSTNAME_FIELD, DEPARTMENT_FIELD, LASTNAME_FIELD, EMAIL_FIELD, PHONE_NUMBER_FIELD, ORGANISATION_FIELD, FUNCTION_FIELD, COMMENTS_FIELD, CONSENT_FIELD } from '../helpers/form-constants'
import { getGenericValidation, scrollToElement, setNecessaryGenericFormFields } from '../helpers/functions'
import { IDownload } from './../store/modules/request-download'
import GenericFormField from './generic-form-field.vue'

@Component({
  template: `
      <div class="generic-form gray" :class='{"generic-form--popup": popup, "wide": !small}'>
        <div class="overflow-container">
          <button v-if='popup' class="close-button" @click='$store.commit("genericForm/close")'>
            <i class="icons8-delete"></i>
          </button>
            <transition name="fade" mode="out-in">
                <div class="rich-text success-message" v-if="isSent" key="success" v-html='form.successMessage'></div>
                <div class="flex flex-column" key="form" v-else>
                    <h3>{{ form.titleForm }}</h3>
                    <p>{{ form.formText }}</p>
                    <div :class='{"grid": !small}'>
                        <generic-form-field class="mt" v-for="(field, index) in form.formFields" :index="index" :number-of-fields="form.formFields.length" v-model="model[field.labelForm]" :field="field" :key="field.labelForm" :error="$v.model[field.labelForm].$error"></generic-form-field>
                        <div v-if='form.consentText' class="form-field form-field--checkbox" :class="{error: consentError, 'generic--checkbox': !consentOnLastRow }">
                          <input id="consent" type='Checkbox' :checked="isChecked" @input='consentRequired($event.target.checked)' />
                          <label for="consent" v-html="form.consentText"></label>
                        </div>
                        <button class="button accent flex-self-end mt" :class="{'two-rows': buttonOverTwoRows}" @click="send" :loading="loading">{{ form.submitButton }}
                          <i class="icons8-chevron-right-2"></i>
                        </button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
  `,
  validations() {
    return getGenericValidation((this as GenericForm).form.formFields)
  },
  components: { GenericFormField }
})
export default class GenericForm extends Vue {
  @Prop() form: any
  @Prop() popup: boolean
  @Prop({ default: false }) small: boolean
  @Prop() vacancyPageId: string

  model: { [key in string]: any } = {}
  loading = false
  isSent = false
  isChecked = false
  consentError = false

  get buttonOverTwoRows(): boolean {
    if(this.consentOnLastRow) return false
    const hasEvenNumberFields =  this.form.formFields.length % 2 === 0
    return this.form.consentText ? hasEvenNumberFields : !hasEvenNumberFields;
  }

  consentRequired (value: boolean): void {
    this.isChecked = value

    if(!this.isChecked) this.consentError = true
    else this.consentError = false
  }

  get consentOnLastRow(): boolean {
    if(this.form && this.form.formFields){
      const numberOfFields = this.form.formFields.length
      // all textAreas except last one count double
      const textAreasWithDifferentRowSize = this.form.formFields.filter((field: any, index: number) =>  !(index + 1 === numberOfFields) && field.type === 'TextArea')
      return  (numberOfFields + textAreasWithDifferentRowSize.length ) % 2 === 0
    }
    return false
  }

  get download(): any {
    return this.$store.state.requestDownload.download
  }

  async send(): Promise<void> {
    this.$v.$touch()
    if (this.$v.$invalid || this.form.consentText && !this.isChecked) {
      this.$nextTick(() => scrollToElement(this.$el, '.error'))
      if(!this.isChecked) this.consentError = true
      else this.consentError = false

      return
    }

    this.loading = true

    try {
      const antiForgeryInput: HTMLInputElement | null = document.querySelector(`input[name=${ANTIFORGERY_INPUT_NAME}]`)
      this.model[ANTIFORGERY_INPUT_NAME] = antiForgeryInput?.value
      this.model['Id'] = this.form.id
      if (this.vacancyPageId) this.model['VacancyPageId'] = this.vacancyPageId

      const isApplicationForm = this.form.formFields.filter((item: any) => item.labelForm == 'CV').length > 0;
      const gtagSendToId = this.vacancyPageId || isApplicationForm ? gtagSendToIdApplicationRequest : this.download ? gtagSendToIdDownloadsRequest : gtagSendToIdContactsRequest;

      const formData = new FormData();

      for ( const key in this.model ) {
        formData.append(key, this.model[key]);
      }

      const res: { data: { success: boolean } } = await Axios.post(`${BASE_URL}/genericcontactform/submit`, formData)

      if (res.data.success) {
        // make sure the popup keeps the same height

        if (window.CURRENT_STORE === 'HakronNL') {
        /* eslint-disable @typescript-eslint/camelcase */
          gtag('event', 'conversion', {
            send_to: gtagSendToId
          });
        }

        if (this.download) {
          const downloadUrl = this.download.fileUrl && this.download.fileUrl.length ? this.download.fileUrl : this.download.file && this.download.file.length ? this.download.file : this.download
          const link = document.createElement('a')
          link.href = downloadUrl
          link.download = downloadUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        this.$nextTick(() => setTimeout(() => scrollToElement(this.$el, '.success-message'), 600))
        this.isSent = true
      } else throw new Error()

    } catch (error) {
      console.error(error)
      this.$store.commit('notifications/add', { message: this.form.errorMessage })
    } finally {
      this.loading = false
    }
  }

  created(): void {
    setNecessaryGenericFormFields(this, this.form.formFields)

  }
}
